export default "__VITE_ASSET__b5e44471__"